export type TabsOptionsType = 'routingRules' | 'generalSettings' | 'myLink' | 'accessControlAffreightment' | 'apiIntegrations' | 'emails' | 'customLogo' | 'financial';

export type TechnologyType = { value: string | null, label: string };
export type VtProviderType = { value: string | null, label: string };
export type PartnerType = { value: string | null, label: string, codEmpresaParceiro?: number };
export type MaxContestsAllowedType = 1 | 2 | 3 | 4 | 5 | 6;
export type TransfersBehaviorType = 'default' | 'unlimited' | 'minimun';
export type KindOfVtSpTransType = 'vt' | 'common';
export type EmailsObjectType = { email: string, emailOwnerName: string };

export const VT_PURCHASE_PROVIDER_NOT_INFORMED = '0';
export const VT_PURCHASE_PROVIDER_SAME_AS_SOURCE = 'SAME';
export const VT_PURCHASE_PROVIDER_SAME_AS_SOURCE_LABEL = 'Mesmo fornecedor da origem acima';

export interface SettingsFromApiI {
  codigo: number
  msg: string
  validado: boolean
  codRetorno: number
  dadosConfig: DadosConfig
  emails: Email[]
  servicosContrato: ServicosContrato[]
}

export interface DadosConfig {
  nomeEnvelopadora: string;
  nomeTecFolhaPg: string;
  nomeParceiro: string;
  nomeParceiro2?: string;
  nomeIntegrador: string;
  codIntegrador: number;
  emailAceite: boolean
  emailExtPA: boolean
  utilizaTeto: boolean
  valorTeto: number
  utilizaTetoValorPadraoEmp?: boolean
  espelhamento: boolean
  usaVTInicial: boolean
  valVTInicial: number
  usaFreta: boolean
  usaHorarioFretado: boolean
  usaLimKm: boolean
  usaMyLinkFull: boolean
  kmLimite: number
  opcaoTextoCarta: number
  envelopadora: number
  envelopadoraFornecedor?: number
  nomeEnvelopadoraFornecedor?: string
  textoCarta: string
  logoCarta: boolean
  tipoBaldeacao: 0 | 1| 2
  regraVTBilSemTx: boolean
  regraBilSemIntegraRJ: boolean
  emailFuncWebC: boolean
  cartaLiberada: boolean
  reprocessaMyLink: boolean
  envioDadosWCAceite: boolean
  MyLinkLogo: boolean
  bloqueiaEmbCAF: boolean
  diasBloqueioCAF: number
  conexaoFolhaPg: boolean
  codTecFolhaPg: number
  codParceiro: number
  codParceiro2?: number
  emailDirect: boolean
  notificaFuncDirect: boolean
  cartaEmBranco: boolean
  totalMaxReclama: 1 | 2 | 3
  distInicial: number
  emailLogo: boolean
  urlArqLogo: string
  urlDocWebC: string
  alteraDadosLT: boolean
  tipoParceiro: boolean
  codEmpresaParceiro: number
  temLogoEmail: boolean
  verificaSalarioRJ: boolean
  atualizaCodVTEnvelp: boolean
  usaWebhook: boolean
  regraVTSemTxAesa: boolean
  acimaTetoBiasTag: boolean
  usaWebhook2: boolean;
  usaWebhookForaAbrang: boolean;
  particularidades: string;
  anexarComprovanteEnd: boolean;
  usaRodoviarioValZero: boolean;
  kmRodoviarioValZero: number;
  geraNFSeparada: boolean;
  geraNFSeparadaMatriz: boolean;
}

export interface Email {
  endMail: string
  codProcesso: number
  nomeUsuario: string
}

export interface ServicosContrato {
  codServ: number
  servico: string
}

export interface SettingsListI {
  codigo: number
  msg: string
  validado: boolean
  tecnoFolhaPg: TecnoFolhaPg[]
  envelopadoras: Envelopadora[]
  parceiros: Parceiro[]
}

export interface TecnoFolhaPg {
  codTecFolhaPg: number
  nomeTecFolhaPG: string
}

export interface Envelopadora {
  codEnvelop: number
  nomeEnvelop: string
}

export interface Parceiro {
  codParceiro: number
  nomeParceiro: string
  codEmpresaParceiro: number
}

